import { jsx } from "react/jsx-runtime";
import { PresenceContext } from "@tamagui/use-presence";
import * as React from "react";
import { useId } from "react";
const PresenceChild = ({
  children,
  initial,
  isPresent,
  onExitComplete,
  exitVariant,
  enterVariant,
  presenceAffectsLayout
}) => {
  const presenceChildren = React.useMemo(newChildrenMap, []);
  const id = useId() || "";
  const context = React.useMemo(
    () => {
      return {
        id,
        initial,
        isPresent,
        exitVariant,
        enterVariant,
        onExitComplete: (id2) => {
          presenceChildren.set(id2, true);
          for (const isComplete of presenceChildren.values()) {
            if (!isComplete) {
              return;
            }
          }
          onExitComplete == null ? void 0 : onExitComplete();
        },
        register: (id2) => {
          presenceChildren.set(id2, false);
          return () => presenceChildren.delete(id2);
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    presenceAffectsLayout ? void 0 : [isPresent, exitVariant, enterVariant]
  );
  React.useMemo(() => {
    presenceChildren.forEach((_, key) => presenceChildren.set(key, false));
  }, [isPresent]);
  React.useEffect(() => {
    !(isPresent || presenceChildren.size) && (onExitComplete == null ? void 0 : onExitComplete());
  }, [isPresent]);
  return /* @__PURE__ */ jsx(PresenceContext.Provider, { value: context, children });
};
function newChildrenMap() {
  return /* @__PURE__ */ new Map();
}
export {
  PresenceChild
};
//# sourceMappingURL=PresenceChild.js.map
